import React, { FC } from "react";
import { useCalenderViewStore } from "@stores/useCalenderViewStore";
import { DatePicker, Switch, Tooltip } from "antd";

import "./kpiCards.scss";
import moment from "moment";
import { getClientName } from "@utils/helpers";
import { dateFormatConfig } from "@utils/constants";
import MonthMasterCards from "../MonthMasterCards";
import DayMasterCards from "../DayMasterCards";
import MarqueeLogo from "../../../../../../assets/images/MarqueeLogo.svg";
import DayFilter from "../DayFilter/DayFilter";
import MonthFilter from "../MonthFilter/monthFilter";

const KPICards: FC<any> = () => {
  const selectedDateCalender = useCalenderViewStore((state) => state.selectedDateCalender);
  const setSelectedDateCalender = useCalenderViewStore((state) => state.setSelectedDateCalender);
  const isMonthChange = useCalenderViewStore((state) => state.isMonthChange);
  const setIsMonthChange = useCalenderViewStore((state) => state.setIsMonthChange);
  const viewForCalender = useCalenderViewStore((state) => state.viewForCalender);
  const setViewForCalender = useCalenderViewStore((state) => state.setViewForCalender);
  const officeName = useCalenderViewStore((state) => state.officeName);
  const monthFilter = useCalenderViewStore((state) => state.monthFilter);

  const onChangeView = (flag: boolean) => {
    setViewForCalender(flag);
  };

  // const onChangeView = (flag: boolean) => {
  //   setViewForCalender(flag);
  // };

  const dateFormat = dateFormatConfig.get(getClientName())["LastActionFormat"];

  const tootltip = () => {
    return (
      <div className="tooltipContainer">
        <div className="tooltipContainer__title">Selected Offices</div>
        {monthFilter.office_name.map((office: any) => (
          <div className="tooltipContainer__title__office">
            <div className="tooltipContainer__title__office__bulletDot"></div>
            <div>{office}</div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <div className="ui-calenderView-kpi-nav">
        <div className="ui-calenderView-kpi-nav__header">
          <div className="ui-calenderView-kpi-nav__header__title-brand-calender">
            <img src={MarqueeLogo} alt="dashboardReport" className="ui-calenderView-kpi-nav__header__title-brand-calender__brandLogo" />
            <div className="ui-calenderView-kpi-nav__header__title-brand-calender__title">Calendar View Report</div>
          </div>
          <div className="ui-calenderView-kpi-nav__header__right-header">
            <div className="ui-calenderView-kpi-nav__header__right-header__viewToggler">
              <div className="ui-calenderView-kpi-nav__header__right-header__viewToggler__month">Month</div>
              <div className="ui-calenderView-kpi-nav__header__right-header__viewToggler__switch">
                <Switch defaultChecked={viewForCalender} onChange={onChangeView} />
              </div>
              <div className="ui-calenderView-kpi-nav__header__right-header__viewToggler__day">Day</div>
            </div>
            <div className="ui-calenderView-kpi-nav__header__right-header__filter">{viewForCalender ? <DayFilter /> : <MonthFilter />}</div>
            <DatePicker
              value={selectedDateCalender}
              format={dateFormat}
              allowClear={false}
              onChange={(value) => {
                if (value) {
                  if (value.month() !== selectedDateCalender.month()) setIsMonthChange(!isMonthChange);
                }
                return value ? setSelectedDateCalender(value) : moment();
              }}
            />
          </div>
        </div>
        <div className="ui-calenderView-kpi-nav__masterCardsAndDateContainer">
          <div className="ui-calenderView-kpi-nav__masterCardsAndDateContainer__monthOrDate_office">
            <div className="ui-calenderView-kpi-nav__masterCardsAndDateContainer__monthOrDate_office__monthOrDate">
              {viewForCalender ? selectedDateCalender.format("dddd, MMMM Do, YYYY") : selectedDateCalender.format("MMMM YYYY")}
            </div>
            <div className="ui-calenderView-kpi-nav__masterCardsAndDateContainer__monthOrDate_office__office">
              <span className="ui-calenderView-kpi-nav__masterCardsAndDateContainer__monthOrDate_office__office__label">Office</span> :{" "}
              <span className="ui-calenderView-kpi-nav__masterCardsAndDateContainer__monthOrDate_office__office__value">
                {viewForCalender ? (
                  officeName
                ) : monthFilter.office_name.length > 0 ? (
                  monthFilter.office_name.length === 1 ? (
                    monthFilter.office_name[0]
                  ) : (
                    <Tooltip placement="bottomRight" title={tootltip} overlayClassName={"officeToolTip"}>
                      <span className="ui-calenderView-kpi-nav__masterCardsAndDateContainer__monthOrDate_office__office__value__tooltip">Multiple</span>
                    </Tooltip>
                  )
                ) : (
                  "No Office Selected"
                )}
              </span>
            </div>
          </div>
          {viewForCalender ? <DayMasterCards /> : <MonthMasterCards />}
        </div>

        {/* <div className="ui-calenderView-kpi-nav__dayCalender-navBar">
          <div className="ui-calenderView-kpi-nav__dayCalender-navBar__header1">
            <div className="ui-calenderView-kpi-nav__dayCalender-navBar__header1__timeStamp">
              {viewForCalender ? selectedDateCalender.format("dddd, MMMM Do, YYYY") : selectedDateCalender.format("MMM YYYY")}
            </div>
            selectedDate.format('dddd MMMM Do, YYYY | LT ||||||   selectedDate.format("MMM YYYY")
          </div>
          <div className="ui-calenderView-kpi-nav__dayCalender-navBar__header2">
            <div className={`ui-calenderView-kpi-nav__dayCalender-navBar__header2__monthButton ${!viewForCalender ? "borderSelected" : ""}`} onClick={() => changeView(false)}>
              Month
            </div>
            <div className={`ui-calenderView-kpi-nav__dayCalender-navBar__header2__dayButton ${viewForCalender ? "borderSelected" : ""}`} onClick={() => changeView(true)}>
              Day
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default KPICards;
